import styled from 'styled-components';
export const Loader = styled.div `
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`;
export const Spinner = styled.div `
  display: flex;
  width: ${(props) => (props.width ? props.width : '100px')};
  height: ${(props) => (props.height ? props.height : '100px')};
  align-items: center;
  justify-content: center;
`;
//# sourceMappingURL=loader.styles.js.map